///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbDateInputBaseComponent } from './../date-input.base.component';
import { TimePickerComponent } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'kb-time-picker',
    templateUrl: './time-picker.component.html',
})
export class KbTimePickerComponent extends KbDateInputBaseComponent {
    @ViewChild(TimePickerComponent)
    public timePicker: TimePickerComponent;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/time-picker/time-picker.component.ts